<template>
  <div class="row">
    <div class="col-lg-12 col-md-12">
      <card class="shadow-lg">
        <div class="row content-add-btn">
          <button class="btn btn-secondary" @click="$router.go(-1)">
            <em class="fa fa-chevron-left"></em>
            {{ $t('common_words.exit') }}
          </button>
        </div>
        <hr />
        <form-wizard
          ref="formWizard"
          v-if="this.isCreate() || this.isUpdate()"
          @on-complete="storeUpdateFarm"
          title
          subtitle
          :back-button-text="$t('common_words.back')"
          :next-button-text="$t('common_words.next')"
          :finish-button-text="$t('common_words.save')"
          class="custom-padding-wz-header"
        >
          <tab-content
            :title="$t('common_words.general_information')"
            :before-change="() => validateStep('firstStep')"
          >
            <first-step
              ref="firstStep"
              @on-validated="onStepValidated"
              @fillbudgetedCardForm="fillbudgetedCardForm"
              @showHideLoading="showHideLoading"
            ></first-step>
          </tab-content>
          <tab-content
            :title="$t('fertilization.fertilizers')"
            :before-change="() => validateStep('secondStep')"
          >
            <second-step
              ref="secondStep"
              @on-validated="onStepValidated"
              @fillbudgetedCardForm="fillbudgetedCardForm"
              @showHideLoading="showHideLoading"
            ></second-step>
          </tab-content>
          <tab-content :title="$t('common_words.confirm')">
            <p class="cm-mg-p-wzd text-center text-muted">
              3.1 {{ $t('common_words.verify_inputed_information') }}
            </p>
            <br />
            <div class="row d-flex justify-content-center">
              <div class="col-9">
                <table class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.year') }}:</strong>
                        </h6>
                        {{ year }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong
                            >{{
                              $t('fertilization.fertilizing_type')
                            }}
                            :</strong
                          >
                        </h6>
                        {{ budgetedCardForm.type }}
                      </td>
                    </tr>
                    <tr class="shadow-sm" v-if="budgetedCardForm.farm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.farm') }}:</strong>
                        </h6>
                        {{ budgetedCardForm.farm.name }}
                      </td>
                    </tr>
                    <tr class="shadow-sm" v-if="budgetedCardForm.lot">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.allotment') }}:</strong>
                        </h6>
                        {{ budgetedCardForm.lot.name }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('production.hectares') }}:</strong>
                        </h6>
                        {{ budgetedCardForm.hectares }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.area') }}:</strong>
                        </h6>
                        {{ budgetedCardForm.area }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong
                            >{{ $t('production.boxes_per_hectare') }} :</strong
                          >
                        </h6>
                        {{ budgetedCardForm.boxes_per_hectare }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.rmr') }}:</strong>
                        </h6>
                        {{ budgetedCardForm.trm }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong
                            >{{ $t('fertilization.fertilizers') }}:</strong
                          >
                        </h6>
                        <br />
                        <ul
                          v-for="(fert, index) in budgetedCardForm.fertilizers"
                          :key="index"
                        >
                          <li>
                            {{ $t('fertilization.fertilizers') }}:
                            {{ formatNumber(fertilizers_names[index]) }}
                          </li>
                          <li>
                            Cantidad Bultos:
                            {{ formatNumber(budgetedCardForm.packages[index]) }}
                          </li>
                          <li>
                            {{ $t('production.bundle_quantity_unit') }}
                            {{
                              formatNumber(
                                budgetedCardForm.packages[index] *
                                  fertilizers_factors[index]
                              )
                            }}
                          </li>
                          <li>
                            {{ $t('production.bundle_values') }}
                            {{
                              formatNumber(
                                budgetedCardForm.package_values[index]
                              )
                            }}
                          </li>
                          <li>
                            {{ $t('production.bundles_ha') }}
                            {{
                              formatNumber(
                                budgetedCardForm.packages[index] /
                                  budgetedCardForm.hectares
                              )
                            }}
                          </li>
                          <li>
                            {{ $t('production.bundle_value_ha') }}
                            {{
                              formatNumber(
                                (budgetedCardForm.packages[index] /
                                  budgetedCardForm.hectares) *
                                  budgetedCardForm.package_values[index]
                              )
                            }}
                          </li>
                        </ul>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </tab-content>
        </form-wizard>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions_operations') }}
          </h5>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import { Axios } from 'src/class/Axios.js';
import { showContinue } from 'src/util/Util.js';
import FirstStep from './steps/FirstStep.vue';
import Formatter from 'src/class/Formatter';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';
import SecondStep from './steps/SecondStep.vue';

export default {
  components: {
    FirstStep,
    SecondStep,
  },
  data() {
    return {
      year: 0,
      budgetedCardForm: {},
      fertilizers_names: [],
      fertilizers_factors: [],
      all_fertilizers: [],
    };
  },
  mixins: [mixinMasters, MixinPermissions, MixinMenu],
  methods: {
    validateStep(ref) {
      return this.$refs[ref].validate();
    },

    formatNumber(value) {
      return Formatter.formatNumber(value);
    },

    cleanAllSteps() {
      this.$refs.firstStep.model = {};
      this.$refs.secondStep.model = {
        fertilizers: [],
        packages: [],
        package_values: [],
        budgeted_card_fertilizer_ids: [],
        budgeted_card_fertilizer_ids_bck: [],
      };
    },

    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },

    fillbudgetedCardForm(ref) {
      this.budgetedCardForm = Object.assign(
        {},
        this.budgetedCardForm,
        this.$refs[ref].model
      );

      if (ref == 'firstStep') {
        this.$refs['secondStep'].type_budgeted =
          sessionStorage.getItem('type_budgeted');
        this.$refs['secondStep'].year_budgeted =
          sessionStorage.getItem('year_budgeted');

        if (this.$refs['secondStep'].type_budgeted == 'Lote') {
          this.$refs['secondStep'].lot_id = sessionStorage.getItem('lot_id');

          let request_data = {
            route: 'grounds/ranges/recommendations',
            nutrients_ids: this.$refs['secondStep'].nutrients_ids,
            nutrients_symbols: this.$refs['secondStep'].nutrients_symbols,
            year: this.$refs['secondStep'].year_budgeted,
            lot_id: this.$refs['secondStep'].lot_id,
            farm_id: this.$refs['firstStep'].model.farm_id,
          };

          Axios.saveMaster(request_data).then((response1) => {
            this.$refs['secondStep'].recommendations = response1.data;
          });
        }
      }

      if (ref == 'secondStep') {
        this.year = moment(String(this.budgetedCardForm.year)).format('YYYY');
        this.fertilizers_names = [];
        this.fertilizers_factors = [];

        this.budgetedCardForm.fertilizers.forEach((elem) => {
          let index = this.all_fertilizers.findIndex(
            (tableRow) => tableRow.id === elem
          );
          this.fertilizers_names.push(this.all_fertilizers[index].name);
          this.fertilizers_factors.push(
            this.all_fertilizers[index].conversion_factor
          );
        });
      }
    },

    storeUpdateFarm() {
      this.showHideLoading(true);
      this.budgetedCardForm.route = 'fertilization/budgeted_cards';

      if (sessionStorage.getItem('editForm')) {
        if (this.isUpdate()) {
          this.budgetedCardForm.id = JSON.parse(
            sessionStorage.getItem('editForm')
          ).id;
          Axios.updateMaster(this.budgetedCardForm)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/fertilization/budgeted_cards',
                'budgetedCardForm'
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          Axios.saveMaster(this.budgetedCardForm)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/fertilization/budgeted_cards',
                'budgetedCardForm'
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },
  },

  created() {
    this.showHideLoading(true);
    Axios.getMasters('fertilization/fertilizers')
      .then((response) => {
        this.all_fertilizers = response.data.data;
        this.showHideLoading();
      })
      .catch((error) => {
        this.showMessageErrors(error);
        this.showHideLoading();
      });
  },

  beforeDestroy() {
    sessionStorage.removeItem('editForm');
  },

  mounted() {
    this.selectedItemOnMenu('fertilization');
  },

  destroyed() {
    this.deselectedItemOnMenu('fertilization');
  },
};
</script>
